module.exports = __webpack_public_path__ + "static/media/dress.db6555dc.glb";